"use strict";
import React, {Fragment, useCallback, useEffect, useState} from 'react';
import {QrScanner} from '@yudiel/react-qr-scanner';
import TextInput from "./TextInput";
import "./CodeScanner.scss";
import Button from "./Button";
import Portal from "../layout/Portal";
import Modal from "../layout/Modal";
import Select from "./Select";

type ScannerProps = {
    onDetected: (result: string) => void,
    cameraId?: string,
}

let defaultCameraId = localStorage.getItem("defaultCameraId") || null;
let defaultCameras = [];

const ScannerInput = (props: ScannerProps&{continuous?: boolean}) => {
    const [scanning, setScanning] = useState(false);
    const [lastResult, setLastResult] = useState<string>(null);
    const onDetected = useCallback((result: string) => {
        if (result !== lastResult) {
            setLastResult(result);
            props.onDetected(result);
            if (props.continuous !== true) {
                setScanning(false);
            }
        }
    }, [lastResult, props.onDetected, props.continuous]);
    useEffect(() => {
        setLastResult(null);
    }, [scanning])
    const [cameras, setCameras] = useState<{id: any, label: any}[]>(defaultCameras);
    const [cameraId, setCameraId] = useState(defaultCameraId);
    useEffect(() => {
        navigator?.mediaDevices?.enumerateDevices()?.then((mediaDevices) => {
            const newCameras: {id: any, label: any}[] = [];
            mediaDevices.forEach((mediaDevice, count) => {
                if (mediaDevice.kind === 'videoinput') {
                    newCameras.push({id: mediaDevice.deviceId, label: mediaDevice.label || `Camera ${count++}`});
                }
            });
            if (!cameraId) {
                setCameraId(defaultCameraId = newCameras[0].id);
                localStorage.setItem("defaultCameraId", defaultCameraId);
            }
            setCameras(defaultCameras = newCameras);
        });
    }, []);
    return (
        <Fragment>
            <Button
                onClick={() => setScanning(!scanning)}
                color="default"
                icon={{lib: "fa", name: "qrcode"}}
                tooltip="Kód beolvasás (QR kód/Vonalkód)"
            />
            <Portal>
                <Modal
                    header="Beolvasás"
                    state={scanning}
                    className="code-scanner"
                    size="large"
                    buttons={[
                        {
                            text: "Bezárás",
                            onClose: true,
                            onClick: () => setScanning(false)
                        }
                    ]}
                >
                    <Select
                        label="Kamera"
                        options={cameras}
                        storetype="local"
                        objectValue={false}
                        value={cameraId}
                        saveChanges={(field, value) => {
                            setCameraId(defaultCameraId = value);
                            localStorage.setItem("defaultCameraId", defaultCameraId);
                        }}
                    />
                    <div className="code-scanner-view">
                        <QrScanner
                            deviceId={cameraId}
                            onDecode={onDetected}
                            onError={(error) => console.log(error?.message)}
                        />
                    </div>
                </Modal>
            </Portal>
        </Fragment>
    );
};

type InputProps = {
    name?: string,
    label?: any,
    required?: boolean,
    value?: string|null|undefined,
    continuous?: boolean,
    onlyScanner?: boolean,
    saveChanges?: (field: string, value: string) => void
}

export default (props: InputProps) => {
    const onDetected = useCallback((result) => {
        props.saveChanges && props.saveChanges(props.name, result);
    }, [props.name, props.saveChanges]);

    const style: {display?: string} = {};
    if (props.label === false) {
        style.display = "none";
    }

    return <Fragment>
        {props.label !== false && <label htmlFor={props.name} className="control-label" style={style}>{props.label} {props.required && <span className="invalid-feedback">*</span>}</label>}
        {props.onlyScanner ? <ScannerInput onDetected={onDetected} /> : <div className="input-group">
            <TextInput {...props} label={false} />
            <span className="input-group-btn">
                <ScannerInput onDetected={onDetected} />
            </span>
        </div>}
    </Fragment>
}